module.exports = __webpack_public_path__ + "img/table.01f69522.svg";